import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/create')({
  component: WorkspaceCreateLayout,
});

function WorkspaceCreateLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
